module.exports = __webpack_public_path__ + "img/bg_winning.a157a075.png";